import { styled } from 'styled-components';

export const ListingViewMainHolder = styled.main`
  flex: 1;
  padding-top: 32px;
`;
